var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "radios-container" },
    _vm._l(_vm.options, function (option) {
      return _c(
        "div",
        { key: option[_setup.props.itemKey], staticClass: "radio-item" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.selectedValue,
                expression: "selectedValue",
              },
            ],
            staticClass: "radio",
            attrs: {
              type: "radio",
              name: option[_setup.props.itemText],
              id: option[_setup.props.itemText],
            },
            domProps: {
              value: option[_setup.props.itemKey],
              checked: _vm._q(
                _setup.selectedValue,
                option[_setup.props.itemKey]
              ),
            },
            on: {
              change: [
                function ($event) {
                  _setup.selectedValue = option[_setup.props.itemKey]
                },
                _setup.handleRadioChange,
              ],
            },
          }),
          _c(
            "label",
            {
              staticClass: "radio-label",
              attrs: { for: option[_setup.props.itemText] },
            },
            [_vm._v(" " + _vm._s(option[_setup.props.itemText]) + " ")]
          ),
          _vm._t("default", null, { item: option }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }